import React from 'react'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { ReduxAsyncConnect } from 'redux-connect'

import ApiClient from 'helpers/ApiClient'
import configureStore from 'redux/create'
import routes from 'routes/routes'

const client = new ApiClient()

const { store, history } = configureStore(window.__PRELOADED_STATE__, client)

delete window.__PRELOADED_STATE__


const helpers = {}

/**
 * Renders a react component into the #react-root div container.
 * Since react 16, the `hydrate` method is used instead of `render` when dealing
 * with server side rendering.
 *
 * @param Component React component that should be rendered
 */
const render = () => {
  return hydrate(
    <Provider store={store} key="provider">
      <ConnectedRouter history={history}>
        <ReduxAsyncConnect helpers={helpers} routes={routes} />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('content')
  )
}

render()

/**
 * This script provides hot module reloading in development mode.
 */
if (module.hot && process.env.NODE_ENV === 'development') {
  module.hot.accept('../../containers/Root', () => {
    const NextApp = require('../../containers/Root').Root

    render(NextApp)
  })
}
